var _rect, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembercardbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 256,
    viewBox: "0 0 1440 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4627_125287)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 256,
    fill: "url(#paint0_linear_4627_125287)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4627_125287",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -206,
    y: -465,
    width: 2143,
    height: 1646
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4627_125287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1020.29 365.604C1020.29 512.864 812.617 644.382 692.512 644.382C572.406 644.382 -178 127.884 -178 -19.3755C-178 -166.635 900.188 36.0952 1020.29 36.0952C1140.4 36.0952 1020.29 218.344 1020.29 365.604Z",
    fill: "url(#paint1_linear_4627_125287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.667 711.129C884.667 858.389 787.302 977.766 667.197 977.766C547.091 977.766 -122 943.441 -122 796.181C-122 648.921 -119.793 262.599 0.312416 262.599C317.569 431.932 574.607 183.793 784.696 278.17C963.07 358.3 847.7 602.59 884.667 711.129Z",
    fill: "url(#paint2_radial_4627_125287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.16 491.86C1601.42 911.172 1386.96 700.45 1785.72 689.834C1848.28 701.885 1954.47 702.457 1878.81 608.346C1784.24 490.707 1814.72 407.618 1696.52 279.45C1578.33 151.282 1506.35 21.0655 1327.91 -182.782C1149.47 -386.63 1135.74 -218.592 934.568 -234.522C733.399 -250.452 825.152 -225.155 547.59 70.6199C270.028 366.395 672.895 72.548 1137.16 491.86Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.592 675.706C522.911 726.764 732.187 711.006 554.429 925.324C519.34 952.639 470.214 1008.15 554.429 1011.68C659.697 1016.09 689.324 1070.3 810.981 1067.15C932.638 1064 1034.12 1086.06 1223.23 1086.06C1412.33 1086.06 1330.39 1001.6 1431.24 903.262C1532.1 804.927 1476.63 841.488 1448.89 559.722C1421.16 277.956 1390.27 624.648 956.592 675.706Z",
    fill: "#D9D9D9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4627_125287)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -18.0781,
    y1: 205.902,
    x2: 1493.5,
    y2: 205.902,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18.0781,
    y1: 44.5318,
    x2: 1493.5,
    y2: 44.5318,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18.0781,
    y1: 125.216,
    x2: 1493.5,
    y2: 125.216,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.1968,
    y1: -145.203,
    x2: 29.1967,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 674.677,
    y1: -145.203,
    x2: 674.677,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.939,
    y1: -145.203,
    x2: 351.939,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 997.412,
    y1: -145.203,
    x2: 997.412,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1320.15,
    y1: -145.203,
    x2: 1320.15,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.568,
    y1: -145.203,
    x2: 190.568,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 836.044,
    y1: -145.203,
    x2: 836.044,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 513.31,
    y1: -145.203,
    x2: 513.31,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1158.78,
    y1: -145.203,
    x2: 1158.78,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.884,
    y1: -145.203,
    x2: 109.884,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 755.361,
    y1: -145.203,
    x2: 755.361,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.623,
    y1: -145.203,
    x2: 432.622,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1078.1,
    y1: -145.203,
    x2: 1078.1,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1400.84,
    y1: -145.203,
    x2: 1400.84,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.255,
    y1: -145.203,
    x2: 271.255,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 916.732,
    y1: -145.203,
    x2: 916.732,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 593.99,
    y1: -145.203,
    x2: 593.99,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1239.47,
    y1: -145.203,
    x2: 1239.47,
    y2: 1022.2,
    stroke: "#353336",
    strokeOpacity: 0.06,
    strokeWidth: 1.2607
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400.681 181.197L403.238 178.608L399.091 174.463L396.503 177.018C395.907 177.614 395.609 178.311 395.609 179.108C395.609 179.905 395.907 180.602 396.503 181.197C397.099 181.793 397.795 182.091 398.592 182.091C399.389 182.091 400.086 181.793 400.681 181.197ZM404.414 177.432L407.002 174.877C407.598 174.281 407.891 173.584 407.88 172.787C407.869 171.99 407.565 171.293 406.969 170.698C406.374 170.124 405.683 169.831 404.897 169.82C404.11 169.809 403.419 170.102 402.824 170.698L400.268 173.286L404.414 177.432ZM401.867 182.416C400.946 183.338 399.848 183.794 398.576 183.783C397.303 183.772 396.206 183.316 395.284 182.416C394.384 181.494 393.928 180.397 393.917 179.124C393.906 177.852 394.362 176.755 395.284 175.832L401.638 169.479C402.538 168.579 403.635 168.129 404.929 168.129C406.224 168.129 407.321 168.579 408.221 169.479C409.143 170.401 409.605 171.498 409.605 172.771C409.605 174.043 409.143 175.14 408.221 176.063L401.867 182.416ZM380.596 179.167C379.831 179.167 379.18 178.898 378.642 178.361C378.105 177.823 377.836 177.172 377.836 176.407V154.593C377.836 153.829 378.105 153.178 378.642 152.64C379.18 152.102 379.831 151.834 380.596 151.834H388.625C388.469 150.962 388.678 150.174 389.251 149.471C389.823 148.768 390.574 148.417 391.503 148.417C392.453 148.417 393.215 148.768 393.788 149.471C394.36 150.174 394.558 150.962 394.38 151.834H402.409C403.174 151.834 403.825 152.102 404.363 152.64C404.9 153.178 405.169 153.829 405.169 154.593V163.447C404.885 163.414 404.6 163.409 404.315 163.431C404.03 163.453 403.746 163.484 403.461 163.526V154.593C403.461 154.287 403.362 154.035 403.165 153.838C402.968 153.641 402.716 153.542 402.409 153.542H380.596C380.289 153.542 380.037 153.641 379.84 153.838C379.643 154.035 379.544 154.287 379.544 154.593V176.407C379.544 176.714 379.643 176.966 379.84 177.163C380.037 177.36 380.289 177.459 380.596 177.459H389.364C389.3 177.743 389.258 178.028 389.236 178.313C389.214 178.598 389.219 178.882 389.252 179.167H380.596ZM391.503 152.589C391.873 152.589 392.179 152.468 392.421 152.226C392.663 151.984 392.784 151.678 392.784 151.308C392.784 150.938 392.663 150.632 392.421 150.39C392.179 150.148 391.873 150.027 391.503 150.027C391.132 150.027 390.826 150.148 390.584 150.39C390.342 150.632 390.221 150.938 390.221 151.308C390.221 151.678 390.342 151.984 390.584 152.226C390.826 152.468 391.132 152.589 391.503 152.589ZM383.815 159.915V158.207H399.19V159.915H383.815ZM383.815 166.354V164.646H399.19V165.343C399.028 165.463 398.879 165.583 398.742 165.702C398.605 165.822 398.455 165.962 398.293 166.125L398.063 166.354H383.815ZM383.815 172.794V171.085H393.333L392.85 171.568C392.644 171.774 392.443 171.978 392.247 172.181C392.051 172.383 391.86 172.588 391.673 172.794H383.815Z",
    fill: "#0DA6B3",
    fillOpacity: 0.19
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M304.75 74.3337C306.362 74.3337 307.875 74.7462 309.288 75.5712C310.7 76.3962 311.938 77.5962 313 79.171C314.062 77.5962 315.3 76.3962 316.712 75.5712C318.125 74.7462 319.638 74.3337 321.25 74.3337C323.582 74.3337 325.54 75.1259 327.124 76.7102C328.708 78.2942 329.5 80.252 329.5 82.5837C329.5 82.7836 329.492 82.9716 329.477 83.1479C329.462 83.3243 329.442 83.5123 329.419 83.7122H327.586C327.616 83.5123 327.637 83.3243 327.649 83.1479C327.661 82.9716 327.667 82.7836 327.667 82.5837C327.667 80.7504 327.056 79.2226 325.833 78.0004C324.611 76.7782 323.083 76.1671 321.25 76.1671C319.79 76.1671 318.444 76.5837 317.21 77.4169C315.976 78.2502 314.871 79.5047 313.896 81.1803H312.104C311.106 79.4811 309.995 78.2207 308.773 77.3991C307.551 76.5777 306.21 76.1671 304.75 76.1671C302.94 76.1671 301.418 76.7782 300.184 78.0004C298.95 79.2226 298.333 80.7504 298.333 82.5837C298.333 82.7836 298.339 82.9716 298.351 83.1479C298.363 83.3243 298.384 83.5123 298.414 83.7122H296.581C296.558 83.5123 296.538 83.3243 296.523 83.1479C296.508 82.9716 296.5 82.7836 296.5 82.5837C296.5 80.252 297.292 78.2942 298.876 76.7102C300.46 75.1259 302.418 74.3337 304.75 74.3337ZM303.114 94.2887H305.674C306.651 95.2594 307.744 96.3125 308.952 97.448C310.161 98.5831 311.51 99.8311 313 101.192C314.49 99.8311 315.839 98.5831 317.048 97.448C318.256 96.3125 319.349 95.2594 320.326 94.2887H322.896C321.806 95.4076 320.566 96.6335 319.177 97.9663C317.788 99.2989 316.192 100.783 314.389 102.419L313 103.674L311.611 102.419C309.808 100.783 308.214 99.2989 306.829 97.9663C305.443 96.6335 304.205 95.4076 303.114 94.2887ZM311.258 95.4171C311.444 95.4171 311.6 95.3613 311.725 95.2498C311.851 95.138 311.952 94.9928 312.027 94.8144L315.101 85.5803L317.552 89.2685C317.704 89.4659 317.883 89.6233 318.087 89.7406C318.292 89.8583 318.523 89.9171 318.782 89.9171H332.25V88.0837H318.955L315.581 83.021C315.491 82.8869 315.372 82.7863 315.223 82.7194C315.074 82.6525 314.913 82.619 314.742 82.619C314.556 82.619 314.394 82.6748 314.257 82.7863C314.119 82.8982 314.025 83.0433 313.973 83.2217L310.899 92.4801L308.388 88.7323C308.235 88.5349 308.057 88.3775 307.852 88.2602C307.648 88.1426 307.417 88.0837 307.158 88.0837H293.75V89.9171H306.975L310.384 95.0151C310.473 95.1725 310.599 95.2788 310.76 95.3341C310.92 95.3894 311.087 95.4171 311.258 95.4171Z",
    fill: "#0DA6B3",
    fillOpacity: 0.19
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.16 184.461L1029.04 182.867V174.817H1026.75C1025.81 174.817 1025 174.481 1024.33 173.808C1023.65 173.136 1023.32 172.328 1023.32 171.384V155.937H1022.75C1022.45 155.937 1022.19 155.835 1021.99 155.631C1021.79 155.427 1021.68 155.174 1021.68 154.873C1021.68 154.572 1021.79 154.319 1021.99 154.117C1022.19 153.914 1022.45 153.812 1022.75 153.812H1029.04V150.134H1027.32C1027.02 150.134 1026.77 150.032 1026.57 149.828C1026.36 149.624 1026.26 149.372 1026.26 149.07C1026.26 148.769 1026.36 148.517 1026.57 148.314C1026.77 148.111 1027.02 148.009 1027.32 148.009H1032.88C1033.18 148.009 1033.43 148.111 1033.64 148.315C1033.84 148.519 1033.94 148.772 1033.94 149.073C1033.94 149.375 1033.84 149.627 1033.64 149.83C1033.43 150.033 1033.18 150.134 1032.88 150.134H1031.16V153.812H1037.46C1037.76 153.812 1038.01 153.914 1038.22 154.118C1038.42 154.322 1038.52 154.575 1038.52 154.876C1038.52 155.178 1038.42 155.43 1038.22 155.633C1038.01 155.836 1037.76 155.937 1037.46 155.937H1036.89V171.384C1036.89 172.328 1036.55 173.136 1035.88 173.808C1035.21 174.481 1034.4 174.817 1033.45 174.817H1031.16V184.461ZM1048.89 183.317C1047.02 183.317 1045.43 182.653 1044.1 181.324C1042.78 179.996 1042.12 178.399 1042.12 176.533V161.658C1042.12 159.793 1042.78 158.196 1044.11 156.867C1045.44 155.539 1047.04 154.875 1048.91 154.875C1050.78 154.875 1052.37 155.539 1053.7 156.867C1055.02 158.196 1055.68 159.793 1055.68 161.658V176.533C1055.68 178.399 1055.02 179.996 1053.69 181.324C1052.36 182.653 1050.76 183.317 1048.89 183.317ZM1026.75 172.692H1033.45C1033.83 172.692 1034.15 172.569 1034.39 172.324C1034.64 172.079 1034.76 171.766 1034.76 171.384V168.36H1030.63C1030.38 168.36 1030.16 168.266 1029.98 168.078C1029.79 167.89 1029.69 167.671 1029.69 167.42C1029.69 167.17 1029.79 166.95 1029.98 166.762C1030.16 166.574 1030.38 166.48 1030.63 166.48H1034.76V162.148H1030.63C1030.38 162.148 1030.16 162.055 1029.98 161.867C1029.79 161.679 1029.69 161.459 1029.69 161.209C1029.69 160.958 1029.79 160.739 1029.98 160.551C1030.16 160.363 1030.38 160.269 1030.63 160.269H1034.76V155.937H1025.44V171.384C1025.44 171.766 1025.57 172.079 1025.81 172.324C1026.06 172.569 1026.37 172.692 1026.75 172.692ZM1048.92 157C1047.63 157 1046.53 157.45 1045.61 158.35C1044.7 159.251 1044.24 160.353 1044.24 161.658V162.721H1053.56V161.658C1053.56 160.353 1053.11 159.251 1052.21 158.35C1051.31 157.45 1050.21 157 1048.92 157ZM1044.24 173.346H1053.56V164.846H1044.24V173.346ZM1048.9 181.192C1050.21 181.192 1051.31 180.736 1052.21 179.824C1053.11 178.911 1053.56 177.815 1053.56 176.533V175.471H1044.24V176.533C1044.24 177.815 1044.7 178.911 1045.61 179.824C1046.52 180.736 1047.62 181.192 1048.9 181.192Z",
    fill: "#0DA6B3",
    fillOpacity: 0.19
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.58 84.0833V82.25H1123.41V84.0833H1110.58ZM1110.58 76.75V74.9167H1123.41V76.75H1110.58ZM1106 89.5833H1119.75C1120.49 89.5833 1121.18 89.745 1121.8 90.0683C1122.42 90.3912 1122.96 90.8454 1123.41 91.4309L1128 97.3892V71.4617C1128 71.1327 1127.89 70.8622 1127.68 70.6505C1127.47 70.4391 1127.2 70.3333 1126.87 70.3333H1107.13C1106.8 70.3333 1106.53 70.4391 1106.31 70.6505C1106.1 70.8622 1106 71.1327 1106 71.4617V89.5833ZM1107.13 99.6667H1127.42L1121.96 92.5483C1121.69 92.1865 1121.36 91.9074 1120.98 91.7109C1120.61 91.5148 1120.19 91.4167 1119.75 91.4167H1106V98.5382C1106 98.8673 1106.1 99.1378 1106.31 99.3495C1106.53 99.5609 1106.8 99.6667 1107.13 99.6667ZM1126.87 101.5H1107.13C1106.28 101.5 1105.58 101.217 1105.01 100.652C1104.45 100.087 1104.16 99.3822 1104.16 98.5382V71.4617C1104.16 70.6178 1104.45 69.9132 1105.01 69.3479C1105.58 68.7826 1106.28 68.5 1107.13 68.5H1126.87C1127.71 68.5 1128.42 68.7826 1128.98 69.3479C1129.55 69.9132 1129.83 70.6178 1129.83 71.4617V98.5382C1129.83 99.3822 1129.55 100.087 1128.98 100.652C1128.42 101.217 1127.71 101.5 1126.87 101.5Z",
    fill: "#378EB3",
    fillOpacity: 0.19
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.74 174.34H1203.42V174.022C1203.42 173.01 1202.83 172.171 1201.63 171.505C1200.43 170.839 1198.92 170.506 1197.08 170.506C1195.25 170.506 1193.74 170.839 1192.54 171.505C1191.34 172.171 1190.74 173.01 1190.74 174.022V174.34ZM1197.08 167.41C1197.89 167.41 1198.57 167.133 1199.13 166.579C1199.68 166.025 1199.96 165.343 1199.96 164.535C1199.96 163.726 1199.68 163.045 1199.13 162.491C1198.57 161.937 1197.89 161.66 1197.08 161.66C1196.28 161.66 1195.59 161.937 1195.04 162.491C1194.49 163.045 1194.21 163.726 1194.21 164.535C1194.21 165.343 1194.49 166.025 1195.04 166.579C1195.59 167.133 1196.28 167.41 1197.08 167.41ZM1186.76 181.416C1185.88 181.416 1185.15 181.121 1184.55 180.53C1183.96 179.939 1183.67 179.202 1183.67 178.32V157.679C1183.67 156.797 1183.96 156.06 1184.55 155.469C1185.15 154.878 1185.88 154.583 1186.76 154.583H1207.41C1208.29 154.583 1209.02 154.878 1209.61 155.469C1210.21 156.06 1210.5 156.797 1210.5 157.679V166.599L1216.33 160.775V175.224L1210.5 169.4V178.32C1210.5 179.202 1210.21 179.939 1209.61 180.53C1209.02 181.121 1208.29 181.416 1207.41 181.416H1186.76ZM1186.76 179.5H1207.41C1207.75 179.5 1208.03 179.389 1208.25 179.168C1208.47 178.947 1208.58 178.664 1208.58 178.32V157.679C1208.58 157.335 1208.47 157.053 1208.25 156.831C1208.03 156.61 1207.75 156.5 1207.41 156.5H1186.76C1186.42 156.5 1186.14 156.61 1185.92 156.831C1185.7 157.053 1185.58 157.335 1185.58 157.679V178.32C1185.58 178.664 1185.7 178.947 1185.92 179.168C1186.14 179.389 1186.42 179.5 1186.76 179.5Z",
    fill: "#0DA6B3",
    fillOpacity: 0.19
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.538 181.625C232.862 181.625 230.583 180.69 228.7 178.821C226.816 176.953 225.875 174.679 225.875 172V171.095C223.658 170.888 221.792 169.956 220.275 168.297C218.758 166.637 218 164.663 218 162.375V152.75H223.25V151H225V156.25H223.25V154.5H219.75V162.375C219.75 164.3 220.435 165.948 221.806 167.319C223.177 168.69 224.825 169.375 226.75 169.375C228.675 169.375 230.323 168.69 231.694 167.319C233.065 165.948 233.75 164.3 233.75 162.375V154.5H230.25V156.25H228.5V151H230.25V152.75H235.5V162.375C235.5 164.663 234.742 166.637 233.225 168.297C231.708 169.956 229.842 170.888 227.625 171.095V172C227.625 174.188 228.394 176.047 229.932 177.578C231.47 179.109 233.337 179.875 235.534 179.875C237.721 179.875 239.581 179.109 241.112 177.578C242.643 176.047 243.409 174.188 243.409 172V169.271C242.59 169.078 241.914 168.647 241.381 167.978C240.848 167.31 240.582 166.541 240.582 165.673C240.582 164.645 240.942 163.771 241.663 163.051C242.383 162.331 243.258 161.971 244.288 161.971C245.317 161.971 246.191 162.331 246.909 163.051C247.627 163.771 247.986 164.645 247.986 165.673C247.986 166.541 247.719 167.31 247.186 167.978C246.654 168.647 245.978 169.078 245.159 169.271V172C245.159 174.679 244.224 176.953 242.355 178.821C240.486 180.69 238.214 181.625 235.538 181.625ZM244.284 167.625C244.824 167.625 245.285 167.435 245.665 167.054C246.046 166.674 246.236 166.214 246.236 165.673C246.236 165.132 246.046 164.672 245.665 164.292C245.285 163.911 244.824 163.721 244.284 163.721C243.743 163.721 243.282 163.911 242.902 164.292C242.522 164.672 242.332 165.132 242.332 165.673C242.332 166.214 242.522 166.674 242.902 167.054C243.282 167.435 243.743 167.625 244.284 167.625Z",
    fill: "#0DA6B3",
    fillOpacity: 0.19
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4627_125287",
    x1: 720,
    y1: 18.8,
    x2: 720,
    y2: 248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94F0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6FEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4627_125287",
    x1: 341.407,
    y1: 54.3755,
    x2: 795.889,
    y2: 296.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4627_125287",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.956 717.388) rotate(-29.3932) scale(777.019 1335.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4627_125287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 256,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4627_125287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2143,
    height: 1646,
    fill: "white",
    transform: "translate(-206 -465)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembercardbg);
export default __webpack_public_path__ + "static/media/membercardbg.a170d6f088d13c17b3b63594f1a8dcc8.svg";
export { ForwardRef as ReactComponent };